import React from 'react';
import { Box, Typography } from '@mui/material';

const SafetyReports: React.FC = () => {
  return (
    <Box p={3}>
      <Typography variant="h2">Safety Reports</Typography>
      <Typography variant="body1" sx={{ mt: 2 }}>
        This is a placeholder Safety Reports page. Implement listing and actions here.
      </Typography>
    </Box>
  );
};

export default SafetyReports;